import { Button, Icon, Paper, Tooltip, Typography, withStyles, withTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Box } from 'react-layout-components';
import Waypoint from 'react-waypoint';
import ContactForm from '../common/ContactForm';
import Container from '../common/Container';
import Spacing from '../common/Spacing';
import FadeFromDown from '../transitions/FadeFromDown';

class Contact extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            worksVisibility: {}
        }
    }

    asyncSetState = (state) =>
        new Promise(a => requestAnimationFrame(() => this.setState({ ...this.state, ...state }, a)))

    doShowWork = (s) =>
        this.setState({ ...this.state, worksVisibility: { ...this.state.worksVisibility, [s]: true } })

    render() {

        const { classes } = this.props

        return (

            <div className={classes.mainContent}>
                <Box column>
                    <Waypoint
                        key={'aqui-zapp'}
                        onEnter={() => this.doShowWork('aqui-zapp')}
                        topOffset={-56}
                        bottomOffset={56}>
                        <div id={'aqui-zapp'}>
                            <FadeFromDown visible={this.state.worksVisibility['aqui-zapp']}>
                                <Container>
                                    <Box className={classes.content} column center>

                                        <Spacing large vertical />
                                        <Spacing large vertical />

                                        <Box center column alignItems="stretch">

                                            <Typography variant={'title'} color={'primary'} align={'center'}>
                                                Contato
                                            </Typography>

                                            <Spacing large vertical />

                                            <Paper className={classes.contactCard}>
                                                <Box column alignItems="stretch">
                                                    <Box className={classes.contactItem} center justifyContent="space-between">

                                                        <Typography variant={'title'}
                                                            noWrap>
                                                            +55 (88) 99426 3541
                                                        </Typography>

                                                        <Spacing />

                                                        <Tooltip title="Copiar">
                                                            <CopyToClipboard text={'+55 (88) 99426 3541'}>
                                                                <Button variant={'flat'} color={'primary'}>
                                                                    <Icon>filter_none</Icon>
                                                                </Button>
                                                            </CopyToClipboard>
                                                        </Tooltip>

                                                    </Box>
                                                    <Box className={classes.contactItem} center justifyContent="space-between">

                                                        <Typography variant={'title'}
                                                            noWrap>
                                                            contato@cytech.com.br
                                                        </Typography>

                                                        <Spacing />

                                                        <Tooltip title="Copiar">
                                                            <CopyToClipboard text={'contato@cytech.com.br'}>
                                                                <Button variant={'flat'} color={'primary'}>
                                                                    <Icon>filter_none</Icon>
                                                                </Button>
                                                            </CopyToClipboard>
                                                        </Tooltip>
                                                    </Box>
                                                </Box>
                                            </Paper>

                                            <Spacing vertical large />
                                            <Spacing vertical large />

                                            <Typography variant={'title'} color={'primary'} align={'center'}>
                                                Envie-nos uma mensagem. Nossa equipe <br/>
                                                está sempre à disposição para exclarecer dúvidas <br/>
                                                e conversar sobre seu projeto.
                                            </Typography>

                                            <Spacing vertical large />

                                            <Paper className={classes.contactCard}>
                                                <ContactForm />
                                            </Paper>

                                        </Box>

                                        <Spacing large vertical />
                                        <Spacing large vertical />

                                    </Box>
                                </Container>
                            </FadeFromDown>
                        </div>
                    </Waypoint>
                </Box>
            </div>
        )
    }

}

Contact.propTypes = {
    classes: PropTypes.any,
}

Contact.defaultProps = {

}

const styles = theme => ({
    scrollContainer: {
    },
    mainContent: {
        paddingTop: 64,
        minHeight: window.innerHeight - 64,
        [theme.breakpoints.down('xs')]: {
            paddingTop: 56,
            minHeight: window.innerHeight - 2 * 56,
        },
    },
    content: {
        width: '100%',
    },
    section: {

    },
    darkSection: {
        backgroundColor: theme.palette.primary.main
    },
    contactCard: {
        overflow: 'hidden'
    },
    contactItem: {
        padding: theme.spacing.unit * 2,
    }
})

export default withTheme()(withStyles(styles)(Contact))


// WEBPACK FOOTER //
// ./src/components/pages/Contact.js